module.exports = __webpack_public_path__ + "img/keyboard_Shift.135363ea.png";